// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1637027245891
      var cssReload = require("../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./src/components/LoadingSpinner/style.scss
// module id = ./src/components/LoadingSpinner/style.scss
// module chunks = 0